import { cpfCompleteMask } from 'app/masks'
import React, { useContext, useState, createContext } from 'react'

const VisibilityContext = createContext({})

export function VisibilityProvider({ children }) {
  const [showCpf, setShowCpf] = useState(false)

  function hideContent(value) {
    if (value) {
      return cpfCompleteMask(value)
    }

    return
  }

  return (
    <VisibilityContext.Provider value={{ setShowCpf, showCpf, hideContent }}>{children}</VisibilityContext.Provider>
  )
}

export function useVisibility() {
  const context = useContext(VisibilityContext)

  return context
}
